import { useState } from 'react';

export type ActiveSourcingItem = { productId: string; lengthId: string };

type ParentOrderForActiveItem =
  | {
      id: string;
      items: Array<{
        platformProductsLengths: {
          id: string;
          platformProduct: { id: string };
        };
      }>;
    }
  | null
  | undefined;

export function useActiveSourcingItem(
  isSourcingMode: boolean,
  parentOrder: ParentOrderForActiveItem,
  parentOrderId: string | null
): [ActiveSourcingItem | null, (item: ActiveSourcingItem | null) => void] {
  const [activeItem, setActiveItem] = useState<ActiveSourcingItem | null>(null);
  const [initializedForOrderId, setInitializedForOrderId] = useState<
    string | null
  >(null);

  if (
    isSourcingMode &&
    parentOrder &&
    parentOrderId &&
    parentOrder.id === parentOrderId &&
    initializedForOrderId !== parentOrderId
  ) {
    const firstItem = parentOrder.items[0];
    if (firstItem) {
      setInitializedForOrderId(parentOrderId);
      setActiveItem({
        productId: firstItem.platformProductsLengths.platformProduct.id,
        lengthId: firstItem.platformProductsLengths.id,
      });
    }
  }

  return [activeItem, setActiveItem];
}
